import React from 'react';
import { Link } from 'react-router-dom';

/**
 * ProductActions - Pure component for product action buttons
 * Follows React Rules: Pure, idempotent, callbacks for side effects
 * 
 * @param {number} productId - Product ID
 * @param {Function} onAddToCart - Callback when add to cart is clicked
 * @param {Function} onAddToWishlist - Callback when wishlist is clicked
 * @param {Function} onQuickView - Callback when quick view is clicked
 */
const ProductActions = ({
  productId,
  onAddToCart,
  onAddToWishlist,
  onQuickView
}) => {
  const handleAddToCart = (e) => {
    e.preventDefault();
    if (onAddToCart) {
      onAddToCart(productId);
    }
  };

  const handleAddToWishlist = (e) => {
    e.preventDefault();
    if (onAddToWishlist) {
      onAddToWishlist(productId);
    }
  };

  const handleQuickView = (e) => {
    e.preventDefault();
    if (onQuickView) {
      onQuickView(productId);
    }
  };

  return (
    <div className="add-actions">
      <ul className="add-actions-link">
        <li className="add-cart active">
          <a href="#" onClick={handleAddToCart}>
            Add to cart
          </a>
        </li>
        <li>
          <a 
            href="#" 
            className="links-details" 
            onClick={handleAddToWishlist}
          >
            <i className="fa fa-heart-o"></i>
          </a>
        </li>
        <li>
          <a 
            href="#" 
            title="quick view" 
            className="quick-view-btn" 
            onClick={handleQuickView}
          >
            <i className="fa fa-eye"></i>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default ProductActions;

